'use strict';

angular.module('mobile-apps').controller('PdConfigurationModalController', [
	'$scope',
	'ModalData',
	'EntryMain',
	'MobileApps',
	'PD',
	'Utilities',
	'$modalInstance',
	'$window',
	'$http',
	'$q',
	function (
		$scope,
		ModalData,
		EntryMain,
		MobileApps,
		PD,
		Utilities,
		$modalInstance,
		$window,
		$http,
		$q
	) {

		$scope.data = {
			pdEnabled: undefined,
			autoDeliverEnabled: undefined,
			pdInstanceName: undefined,
			selectedInstance: undefined,
			isInternal: undefined,
			paClientTicket: undefined,
			pdProjectShortcode: undefined,
			externalUrl: undefined,
			externalUsername: undefined,
			externalPassword: undefined,
			pdInstances: []
		};


		$scope.instanceChanged = function() {
			if ($scope.data.pdInstanceName) {
				$scope.data.selectedInstance = $scope.data.pdInstances.find(function(instance) { return instance.name === $scope.data.pdInstanceName; });
				if ($scope.data.selectedInstance) {
					$scope.data.isInternal = $scope.data.selectedInstance.internal;
					return;
				}
			}

			$scope.data.isInternal = null;
		};


		$scope.savePDSettings = function() {
			$scope.isLoading = true;

			var sendData = {
				mobileAppId: $scope.mobileApp._id,
				enabled: $scope.data.pdEnabled,
				autoDeliver: $scope.data.autoDeliverEnabled,
				instanceName: $scope.data.pdInstanceName,
				projectShortcode: $scope.data.pdProjectShortcode
			};

			if (!$scope.data.isInternal) {
				sendData.url = $scope.data.externalUrl;
				sendData.username = $scope.data.externalUsername;
				sendData.password = $scope.data.externalPassword;
			}
			else {
				sendData.paClientTicket = $scope.data.paClientTicket;
			}

			PD.configure(sendData).$promise
				.then(
					function(data) {
						$scope.isLoading = false;

						Utilities.showMessage('Success', 'Project Director map configuration saved!', 'success');
						$modalInstance.close({ 
							success: true,
							data: data
						});
					}
				)
				.catch(
					function(error) {
						$scope.isLoading = false;
						Utilities.showMessageErrorResponse(error);
					}
				);
		};


		/**
		 * Close modal
		 */
		$scope.close = function() {
			$modalInstance.dismiss();
		};


		/**
		 * Initializes the needed data
		 */
		$scope.init = function() {
			$scope.initializingData = true;

			var mobileApp = ModalData.mobileApp;
			$scope.mobileApp = mobileApp;

			PD.instances({ mobileAppId: $scope.mobileApp._id }).$promise
				.then(function(data) {
					data.forEach(function(internalInstance) {
						 internalInstance.internal = true; 
					});
					data.push({
						name: 'external',
						description: 'External',
						internal: false
					});
					$scope.data.pdInstances = data;

					if (mobileApp.pdEnabled) {
						$scope.data.pdEnabled = true;
					}
					else {
						$scope.data.pdEnabled = false;
					}
		
					if (mobileApp.autoDeliverEnabled) {
						$scope.data.autoDeliverEnabled = true;
					}
					else {
						$scope.data.autoDeliverEnabled = false;
					}
		
					$scope.data.pdInstanceName = mobileApp.pdInstanceName;
					$scope.data.paClientTicket = mobileApp.paClient ? mobileApp.paClient.ticket : '';
					$scope.data.pdProjectShortcode = mobileApp.pdProject ? mobileApp.pdProject.shortcode : '';
					$scope.data.externalUrl = mobileApp.externalPdURL;
					$scope.data.externalUsername = mobileApp.externalPdUsername;
					$scope.data.externalPassword = mobileApp.externalPdPassword;

					$scope.instanceChanged();
		
					$scope.initializingData = false;
				})
				.catch(function(error) {
					$scope.initializingData = false;
					Utilities.showMessageErrorResponse(error);
				});
			
		};


		$scope.init();
	}
]);
